import { useState, useEffect, useRef } from 'react';
import '../App.css';
import AutocompletePaginado from './AutocompletePaginado';
import Table from './Table';
import {useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import { handleErrors, request } from '../utils/ApiUtils';
import Input from './Input';
import AutoCompleteSimples from './AutoCompleteSimples';
import { getActualDate } from '../utils/DateUtils';
import CollapsibleFilters from './CollapsibleFilters';
import { getStatusBadgeStyle } from '../utils/StatusStyleUtils';
import { FaFileContract } from 'react-icons/fa';

function Contratos() {
    const [cliente, setCliente] = useState({})
    const firstRender = useRef(0);
    const [status, setStatus] = useState({})
    const [data, setData] = useState(getActualDate())
    const [endereco, setEndereco] = useState({})
    const [loading, setLoading] = useState({loading: false});
    const [fetchListError, setFetchListError] = useState();
    
    const searchTimeoutRef = useRef(null);

    const navigate = useNavigate();
    const [pageData, setPageData] = useState([]);
    const [dataArray, setDataArray] = useState([]);

    const agendarPesquisa = (time = 1000) => {
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current); 
        }

        searchTimeoutRef.current = setTimeout(() => carregarDados(), time);
    };

    const estados = [
        { id: 'AC', label: 'AC' },
        { id: 'AL', label: 'AL' },
        { id: 'AP', label: 'AP' },
        { id: 'AM', label: 'AM' },
        { id: 'BA', label: 'BA' },
        { id: 'CE', label: 'CE' },
        { id: 'DF', label: 'DF' },
        { id: 'ES', label: 'ES' },
        { id: 'GO', label: 'GO' },
        { id: 'MA', label: 'MA' },
        { id: 'MT', label: 'MT' },
        { id: 'MS', label: 'MS' },
        { id: 'MG', label: 'MG' },
        { id: 'PA', label: 'PA' },
        { id: 'PB', label: 'PB' },
        { id: 'PR', label: 'PR' },
        { id: 'PE', label: 'PE' },
        { id: 'PI', label: 'PI' },
        { id: 'RJ', label: 'RJ' },
        { id: 'RN', label: 'RN' },
        { id: 'RS', label: 'RS' },
        { id: 'RO', label: 'RO' },
        { id: 'RR', label: 'RR' },
        { id: 'SC', label: 'SC' },
        { id: 'SP', label: 'SP' },
        { id: 'SE', label: 'SE' },
        { id: 'TO', label: 'TO' }
    ];


    const carregarDados = async (page = 0) => {
        setLoading({loading: true});

        request(`contratos/paginated?page=${page}`, {
            type: 'POST',
            body: JSON.stringify({
                cliente: cliente?.id ? cliente : null,
                status: status?.id ? status : null,
                cidade: endereco?.cidade,
                uf: endereco?.uf?.id,
                data: data || null,
            }),
            callback: (data) => (
                setLoading({loading: false}),
                setPageData(data),
                setDataArray(data.content)
            ),
            callbackError: (responseData, message) => { handleErrors(responseData, 'Falha ao buscar contratos: '+message, {setFetchListError}) },
            finally: () => {
                setLoading({loading: false})
            }
        })
    };

    useEffect(() => {
        //first render 0
        carregarDados();
    }, []);

    useEffect(() => {
        if (firstRender.current < 2) {
            firstRender.current = firstRender.current+1;
            return;
        }
        agendarPesquisa();
    }, [endereco]);

    useEffect(() => {
        if (firstRender.current < 2) {
            firstRender.current = firstRender.current+1;
            return;
        }
        carregarDados();
    }, [cliente, status]);


    const salvarContrato = async (contrato) => {
        request(`contratos`, {
            type: 'POST',
            body: JSON.stringify(contrato),
            callback: (data) => (
                showNotification('Contrato alterado', 'success')
            ),
            callbackError: (message) => showNotification('Não foi possível salvar as alterações', 'error'),
            finally: () => setLoading({loading: false})
        })
    };

    const onChangeStatus = (contrato, statusSelecionado) => {
        contrato.status = statusSelecionado?.item;
        salvarContrato(contrato);
    }

    const limparFiltros = () => {
        setCliente({});
        setStatus({});
        setEndereco({});
        setData(null);
    };

    function showNotification(message, type = 'success') {
        let container = document.getElementById('notification-container');

        if (!container) {
            container = document.createElement('div');
            container.id = 'notification-container';
            container.className = 'notification-container';
            document.body.appendChild(container);
        }

        const notification = document.createElement('div');
        notification.className = `notification ${type}`;
        notification.textContent = message;

        container.appendChild(notification);

        setTimeout(() => { container.removeChild(notification); }, 2000);
    }

    const tableParams = {
        query: (page) => carregarDados(page),
        columns: [
            {
                label: "Nº Contrato",
                width: "8%",
                type: "input",
                disable: true,
                key: "numero"
            },
            {
                label: "Dt. Contrato",
                width: "10%",
                type: "date",
                disabled: true,
                key: "data"
            },
            {
                label: "Cliente",
                width: "20%",
                type: "input",
                key: "cliente.nome",
                disabled: true,
                getValue: (item) => (item.cliente?.nome || '')
            },
            {
                label: "Honorários iniciais",
                width: "12%",
                disabled: true,
                type: "input-decimal",
                css: "decimal",
                key: "honorarioInicial"
            },
            {
                label: "Cidade",
                width: "20%",
                type: "input",
                key: "cliente.endereco.cidade",
                disabled: true,
                getValue: (item) => (item.cliente?.endereco?.cidade || '')
            },
            {
                label: "UF",
                width: "6%",
                type: "input",
                key: "cliente.endereco.uf",
                disabled: true,
                getValue: (item) => (item.cliente?.endereco?.uf || '')
            },
            {
                label: "Status",
                width: "14%",
                type: "autocomplete",
                css: "status-badge",
                // key: "status.status",
                component: {
                    endpoint: "contratos/status",
                    parameters: {
                        disabled: true,
                        width: '100%',
                        bodyToSearch: { statusContrato: true },
                        getLabel: (contrato) => contrato.status || '',
                        onChange: (contrato, statusSelecionado) => onChangeStatus(contrato, statusSelecionado),
                        getValue: (contrato) => contrato.status,
                        inputStyle: (status) => (
                            {
                                color: 'black',
                                // fontWeight: 'bold',
                                backgroundImage: `radial-gradient(circle, ${status?.item?.color || 'black'} 45%, transparent 50%)`,
                                backgroundPosition: '8px center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '16px 16px',
                                paddingLeft: '28px'
                            }
                        ),
                        POST: true,
                        reload: !!loading?.loading
                    },
                }
            },
            {
                label: "Visualizar",
                width: "5%",
                type: "button-icon",
                css: "button",
                icon: (<VisibilityIcon />),
                title: "Visualizar contrato",
                onClick: (contrato) => navigate(`/contratos/cadastro/${contrato.id}`)
            }
        ]
    };

    return (
        <div className="form-container list-page">
            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex,",
                flexDirection: "column-reverse",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                bottom: "0,",
                right: "30px",
                maxHeight: "100vh"
            }}></div>
            <div className="header-container">
                <div className="page-title-content">
                    <FaFileContract aria-hidden="true" />
                    <h1 style={{ color: 'black' }}>Contratos</h1>
                </div>
                <Button className="new-contract-button" variant="contained" onClick={() => navigate(`/contratos/cadastro`)}>
                    Novo contrato
                </Button>
            </div>

            <CollapsibleFilters
                className="contracts-filters"
                actions={<button type="button" className="clear-filters-button" onClick={limparFiltros}>Limpar filtros</button>}
            >

                <div className='row'>
                    <AutocompletePaginado label={"Cliente"}
                        parameters={{
                            width: '25%',
                            getLabel: ((item) => (item.nome + (item.documento ? ` - ${item.documento}` : ''))),
                            onChange: (item) => {
                                const clienteSelecionado = item?.item;
                                if (clienteSelecionado) {
                                    const ufCliente = clienteSelecionado.endereco?.uf? {id: clienteSelecionado.endereco?.uf} : endereco?.uf;
                                    setEndereco({ ...endereco, cidade: clienteSelecionado.endereco?.cidade, uf: ufCliente })
                                }
                                setCliente(item?.item);
                            }
                        }}
                        endpoint={"clientes/paginated"} />

                    <Input id="cidade" value={endereco?.cidade} parameters={{ width: '25%', label: "Cidade", onChange: (value) => setEndereco({ ...endereco, cidade: value }) }} />

                    <AutoCompleteSimples
                        label="UF"
                        value={endereco?.uf}
                        width='8%'
                        options={estados}
                        getLabel={(item) => item.label}
                        onChange={(ufSelecionada) => setEndereco({ ...endereco, uf: ufSelecionada })} />

                    <AutocompletePaginado label={"Status"}
                        parameters={{
                            bodyToSearch: { statusContrato: true },
                            width: '12%',
                            getLabel: ((item) => (item.status)),
                            onChange: (statusSelecionado) => setStatus(statusSelecionado?.item),
                            inputStyle: (status) => (
                                status ?
                            {
                                color: 'black',
                                // fontWeight: 'bold',
                                backgroundImage: `radial-gradient(circle, ${status?.item?.color || 'black'} 45%, transparent 50%)`,
                                backgroundPosition: '8px center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '14px 14px',
                                paddingLeft: '28px'
                            } : {}
                        )
                        }}
                        endpoint={"contratos/status"} />
                </div>
            </CollapsibleFilters>


            <Table params={{ ...tableParams, containerClassName: 'contracts-table' }} dataArray={dataArray} pageData={pageData} loading={loading} errorOccurred={fetchListError}/>
        </div>
    );
}

export default Contratos;
